import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { FormUploadMmssDocumentComponent } from './form-upload-document/form-upload-document.component';

@Component({
  selector: 'app-dialog-upload-document',
  templateUrl: './dialog-upload-document.component.html',
  styleUrls: ['./dialog-upload-document.component.scss'],
})
export class DialogUploadDocumentComponent {
  modalTrigger$: Subject<any>;
  isEditMode: boolean = false;
  document: any = null;

  constructor(
    public dialogRef: MatDialogRef<DialogUploadDocumentComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: { modalTrigger$: Subject<any>; isEditMode?: boolean; document?: any },
  ) {
    this.modalTrigger$ = data?.modalTrigger$ || new Subject<any>();
    this.isEditMode = data?.isEditMode || false;
    this.document = data?.document || null;
  }

  closeDialog() {
    this.dialogRef.close();
  }
}
